import axios from "axios";

const API_BASE = "https://go.7cut.video";
const TOKEN_KEY = "access_token";
const EXPIRES_KEY = "access_token_expires_at";
const REFRESH_LOCK = "7cut-token-refresh";

export const REFRESH_LEEWAY_SEC = 60;

const listeners = { refreshed: new Set(), expired: new Set() };

const emit = (name, payload) => {
  listeners[name].forEach((cb) => {
    try {
      cb(payload);
    } catch (e) {}
  });
};

export const onTokenRefreshed = (cb) => {
  listeners.refreshed.add(cb);
  return () => listeners.refreshed.delete(cb);
};

export const onSessionExpired = (cb) => {
  listeners.expired.add(cb);
  return () => listeners.expired.delete(cb);
};

export const API_URL = API_BASE;

export const getAccessToken = () => localStorage.getItem(TOKEN_KEY);

const decodeJwtExpiry = (token) => {
  try {
    const [, payload] = token.split(".");
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = JSON.parse(atob(normalized));
    return json.exp ? json.exp * 1000 : null;
  } catch (e) {
    return null;
  }
};

export const saveAccessToken = (token, expiresIn) => {
  if (!token) return null;
  localStorage.setItem(TOKEN_KEY, token);

  const expiresAt = expiresIn
    ? Date.now() + expiresIn * 1000
    : decodeJwtExpiry(token) || Date.now() + 5 * 60 * 1000;
  localStorage.setItem(EXPIRES_KEY, String(expiresAt));

  return token;
};

export const getAccessTokenExpiresAt = () => {
  const raw = localStorage.getItem(EXPIRES_KEY);
  if (raw) return Number(raw);
  const token = getAccessToken();
  return token ? decodeJwtExpiry(token) : null;
};

export const clearAccessToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRES_KEY);
};

export const isAuthUrl = (url = "") => /\/api\/v1\/auth\//.test(url);

let refreshPromise = null;

const doRefresh = async () => {
  const expiresAt = getAccessTokenExpiresAt();
  if (expiresAt && expiresAt - Date.now() > REFRESH_LEEWAY_SEC * 1000) {
    return getAccessToken();
  }

  const response = await axios.post(
    `${API_BASE}/api/v1/auth/refresh`,
    {},
    { withCredentials: true }
  );

  const data = response.data || {};
  if (!data.access_token) {
    throw new Error("refresh вернул ответ без access_token");
  }

  saveAccessToken(data.access_token, data.expires_in);
  emit("refreshed", data.access_token);
  return data.access_token;
};

export const refreshAccessToken = () => {
  if (refreshPromise) return refreshPromise;

  refreshPromise = (
    navigator.locks && navigator.locks.request
      ? navigator.locks.request(REFRESH_LOCK, doRefresh)
      : doRefresh()
  )
    .catch((error) => {
      const status = error.response?.status;
      if (status === 401 || status === 400) {
        clearAccessToken();
        emit("expired", error);
      }
      throw error;
    })
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
};

export const setupCrossTabTokenSync = () => {
  const onStorage = (event) => {
    if (event.key === TOKEN_KEY && event.newValue) {
      emit("refreshed", event.newValue);
    }
  };
  window.addEventListener("storage", onStorage);
  return () => window.removeEventListener("storage", onStorage);
};
